(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mainnex-featured-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.mnx3Ready==='true')return;
    var rail=root.querySelector('[data-mnx3-rail]');
    if(!rail)return;
    var cards=Array.from(rail.querySelectorAll('[data-mnx3-card]'));
    var dotsContainer=root.querySelector('[data-mnx3-dots]');
    if(!cards.length||!dotsContainer)return;
    root.dataset.mnx3Ready='true';
    var active=0,frame=null;
    var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dots=cards.map(function(card,i){
      var dot=document.createElement('button');
      dot.type='button';
      dot.className='mnx3-showcase__dot';
      dot.setAttribute('aria-label','View product '+(i+1)+' of '+cards.length);
      dot.addEventListener('click',function(){go(i)});
      dotsContainer.appendChild(dot);
      return dot;
    });
    function closest(){
      var bounds=rail.getBoundingClientRect(),middle=bounds.left+bounds.width/2;
      var closestIndex=0,closestDistance=Infinity;
      cards.forEach(function(card,i){
        var r=card.getBoundingClientRect();
        var diff=Math.abs(r.left+r.width/2-middle);
        if(diff<closestDistance){closestDistance=diff;closestIndex=i}
      });
      return closestIndex;
    }
    function display(){
      if(drag&&drag.down)return;
      active=closest();
      cards.forEach(function(card,i){card.classList.toggle('is-active',i===active)});
      dots.forEach(function(dot,i){dot.setAttribute('aria-current',String(i===active))});
    }
    function go(index,instant){
      index=Math.max(0,Math.min(cards.length-1,index));
      var card=cards[index];
      if(!card)return;
      var cardBounds=card.getBoundingClientRect(),viewBounds=rail.getBoundingClientRect();
      var shift=cardBounds.left+cardBounds.width/2-(viewBounds.left+viewBounds.width/2);
      rail.scrollBy({left:shift,behavior:(reduce||instant)?'instant':'smooth'});
      active=index;
      cards.forEach(function(el,i){el.classList.toggle('is-active',i===index)});
      dots.forEach(function(dot,i){dot.setAttribute('aria-current',String(i===index))});
    }
    var drag=null,suppressClick=false;
    rail.addEventListener('pointerdown',function(e){
      if(e.pointerType!=='mouse'||e.button!==0)return;
      drag={down:true,pointerId:e.pointerId,x:e.clientX,left:rail.scrollLeft,moved:false};
    });
    rail.addEventListener('pointermove',function(e){
      if(!drag||!drag.down||e.pointerId!==drag.pointerId)return;
      var dx=e.clientX-drag.x;
      if(!drag.moved && Math.abs(dx)<8)return;
      if(!drag.moved){
        drag.moved=true;
        rail.style.scrollSnapType='none';
        try{rail.setPointerCapture(e.pointerId)}catch(error){}
      }
      rail.scrollLeft=drag.left-dx;
      e.preventDefault();
    });
    function endDrag(){
      if(!drag)return;
      var moved=drag.moved;
      drag=null;
      rail.style.scrollSnapType='';
      if(moved){
        suppressClick=true;
        window.setTimeout(function(){suppressClick=false},0);
        requestAnimationFrame(function(){go(closest())});
      }
    }
    rail.addEventListener('pointerup',endDrag);
    rail.addEventListener('pointercancel',endDrag);
    rail.addEventListener('lostpointercapture',endDrag);
    rail.addEventListener('click',function(e){
      if(suppressClick){e.preventDefault();e.stopImmediatePropagation();suppressClick=false}
    },true);
    rail.addEventListener('dragstart',function(e){if(e.target.closest('a, img'))e.preventDefault()});
    rail.addEventListener('scroll',function(){
      if(frame!==null)cancelAnimationFrame(frame);
      frame=requestAnimationFrame(function(){frame=null;display()});
    },{passive:true});
    rail.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight'){e.preventDefault();go(active+1)}
      else if(e.key==='ArrowLeft'){e.preventDefault();go(active-1)}
    });
    var resizeTimer=null;
    window.addEventListener('resize',function(){
      if(resizeTimer!==null)window.clearTimeout(resizeTimer);
      resizeTimer=window.setTimeout(function(){go(active,true)},90);
    },{passive:true});
    requestAnimationFrame(function(){go(0,true)});
  }
  function load(scope){
    (scope||document).querySelectorAll('[data-mnx3-carousel]').forEach(init);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){load(document)});
  else load(document);
  document.addEventListener('shopify:section:load',function(e){load(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mainnex-video-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(scope){
  (scope||document).querySelectorAll('[data-mnx55-carousel]').forEach(function(root){
   if(root.dataset.mnx55Ready==='true')return;
   var slides=Array.from(root.querySelectorAll('[data-mnx55-slide]'));
   var dots=Array.from(root.querySelectorAll('[data-mnx55-dot]'));
   if(!slides.length)return;
   root.dataset.mnx55Ready='true';
   var current=0;
   var timer=null;
   var paused=false;
   var playing=false;
   var visible=!('IntersectionObserver' in window);
   var reduced=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   var enabled=root.dataset.mnx55Autoplay==='true' && slides.length>1 && !reduced;
   var interval=Math.max(5000,Math.min(15000,(parseInt(root.dataset.mnx55Duration,10)||7)*1000));
   var pauseButton=root.querySelector('[data-mnx55-pause]');
   function fallbackThumb(img){
    var thumb=img.getAttribute('src');
    var level=parseInt(img.dataset.mnx55Quality||'0',10);
    if(level>=2)return;
    var next=level===0?'sddefault.jpg':'hqdefault.jpg';
    img.dataset.mnx55Quality=String(level+1);
    img.src=thumb.replace(/(maxresdefault|sddefault|hqdefault)\.jpg(?:\?.*)?$/,next);
   }
   root.querySelectorAll('[data-mnx55-thumb]').forEach(function(img){
    img.dataset.mnx55Quality='0';
    img.addEventListener('error',function(){fallbackThumb(img)});
    img.addEventListener('load',function(){if(img.naturalWidth>0&&img.naturalWidth<=120)fallbackThumb(img)});
    if(img.complete&&img.naturalWidth>0&&img.naturalWidth<=120)fallbackThumb(img);
   });
   function clear(){if(timer!==null){window.clearTimeout(timer);timer=null}}
   function canRotate(){
    
    var active=document.activeElement;
    var keyboardFocus=!!(active && root.contains(active) && active.matches && active.matches(':focus-visible'));
    return enabled && !paused && !playing && visible && !document.hidden && !keyboardFocus ;
   }
   function schedule(){
    clear();
    if(canRotate())timer=window.setTimeout(function(){show(current+1);},interval);
   }
   function updatePause(){
    if(!pauseButton)return;
    root.classList.toggle('mnx73-paused',paused);
     pauseButton.setAttribute('aria-pressed',String(paused));
    pauseButton.setAttribute('aria-label',paused?'Resume automatic slide rotation':'Pause automatic slide rotation');
    pauseButton.title=paused?'Play slideshow':'Pause slideshow';
    var span=pauseButton.querySelector('span');
    if(span)span.textContent=paused?'▶':'Ⅱ';
    if(!enabled)pauseButton.hidden=true;
   }
   function stop(slide){
    if(!slide)return;
    var player=slide.querySelector('[data-mnx55-player]');
    var close=slide.querySelector('[data-mnx55-close]');
    if(player){player.replaceChildren();player.hidden=true}
    if(close)close.hidden=true;
    playing=false;
   }
   function show(index){
     index=(index+slides.length)%slides.length;
     var previous=current;
     var changing=index!==previous;
     if(changing)stop(slides[previous]);
     slides.forEach(function(slide,i){
      var active=i===index;
      if(active){
       slide.hidden=false;
       slide.classList.remove('is-leaving');
       if(changing && !reduced){
        slide.classList.remove('is-active');
        slide.getBoundingClientRect();
       }
      }else if(changing && i===previous && !reduced){
       slide.hidden=false;
       slide.classList.add('is-leaving');
       window.setTimeout(function(){
        if(!slide.classList.contains('is-active')){
         slide.hidden=true;
         slide.classList.remove('is-leaving');
        }
       },730);
      }else{
       slide.hidden=true;
       slide.classList.remove('is-leaving');
      }
      slide.setAttribute('aria-hidden',String(!active));
      slide.classList.toggle('is-active',active);
     });
     dots.forEach(function(dot,i){
      dot.classList.toggle('is-active',i===index);
      dot.setAttribute('aria-current',String(i===index));
     });
     current=index;
     schedule();
    }
    function play(slide){
    var button=slide.querySelector('[data-mnx55-play]');
    var videoId=button&&button.dataset.videoId;
    if(!videoId||!/^[A-Za-z0-9_-]{11}$/.test(videoId))return;
    stop(slide);
    var player=slide.querySelector('[data-mnx55-player]');
    var close=slide.querySelector('[data-mnx55-close]');
    if(!player)return;
    playing=true;
    schedule();
    var iframe=document.createElement('iframe');
    iframe.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(videoId)+'?autoplay=1&playsinline=1&rel=0';
    iframe.title='Mainnex featured YouTube video';
    iframe.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy='strict-origin-when-cross-origin';
    iframe.allowFullscreen=true;
    iframe.loading='eager';
    player.appendChild(iframe);
    // This gesture surface sits ABOVE the cross-origin YouTube iframe,
    // allowing a horizontal drag to be captured by the Mainnex page.
    // Keep the native YouTube controls along the bottom of the frame usable.
    var gesture=document.createElement('div');
    gesture.className='mnx61-player-gesture';
    gesture.setAttribute('data-mnx61-gesture','');
    gesture.setAttribute('role','group');
    gesture.setAttribute('aria-label','Drag left or right to change video. Use the controls at the bottom to pause, seek, or change volume.');
    var hint=document.createElement('span');
    hint.className='mnx61-player-gesture__hint';
    hint.setAttribute('aria-hidden','true');
    hint.textContent='↔ Drag / Swipe to switch videos';
    gesture.appendChild(hint);
    player.appendChild(gesture);
    player.hidden=false;
    if(close){close.hidden=false;close.focus()}
   }
   root.querySelectorAll('[data-mnx55-play]').forEach(function(btn){
    btn.addEventListener('click',function(){play(btn.closest('[data-mnx55-slide]'))});
   });
   root.querySelectorAll('[data-mnx55-close]').forEach(function(btn){
    btn.addEventListener('click',function(){
     var slide=btn.closest('[data-mnx55-slide]');
     stop(slide);
     var playBtn=slide.querySelector('[data-mnx55-play]');
     if(playBtn)playBtn.focus();
     schedule();
    });
   });
   dots.forEach(function(dot,i){dot.addEventListener('click',function(){show(i)})});
   var prev=root.querySelector('[data-mnx55-prev]');
   var next=root.querySelector('[data-mnx55-next]');
   if(prev)prev.addEventListener('click',function(){show(current-1)});
   if(next)next.addEventListener('click',function(){show(current+1)});
   if(pauseButton)pauseButton.addEventListener('click',function(){
    paused=!paused;
    updatePause();
    schedule();
   });
   // Capture a drag at its origin, then change slides DURING movement.
   // Native pointer capture prevents losing the mouse over iframe boundaries.
   // The overlay above cross-origin YouTube handles events for an active player.
   var viewport=root.querySelector('.mnx55-hero__viewport');
   if(viewport){
    var drag=null;
    var wheelLock=0;
    function isInteractive(target){
     return !!(target && target.closest && target.closest('a, button, iframe, input, select, textarea'));
    }
    function isPlayerGesture(target){
     return !!(target && target.closest && target.closest('[data-mnx61-gesture]'));
    }
    function goSwipe(direction,continuePlaying){
     show(current+direction);
     if(continuePlaying)play(slides[current]);
    }
    function onPointerDown(e){
     if(e.isPrimary===false)return;
     if(e.pointerType==='mouse'&&e.button!==0)return;
     if(isInteractive(e.target))return;
     if(playing&&!isPlayerGesture(e.target))return;
     drag={
      id:e.pointerId,
      type:e.pointerType,
      x:e.clientX,
      y:e.clientY,
      changed:false,
      nextPlaying:false
     };
     try{viewport.setPointerCapture(e.pointerId)}catch(err){}
     if(e.pointerType==='mouse'&&e.cancelable)e.preventDefault();
    }
    function onPointerMove(e){
     if(!drag||e.pointerId!==drag.id||drag.changed)return;
     var dx=e.clientX-drag.x;
     var dy=e.clientY-drag.y;
     var threshold=drag.type==='mouse'?42:38;
     if(Math.abs(dx)<threshold||Math.abs(dx)<Math.abs(dy)*1.25)return;
     drag.changed=true;
     drag.nextPlaying=playing;
     // Immediate visible slide change while dragging, not after mouse release.
     show(current+(dx<0?1:-1));
     if(e.cancelable)e.preventDefault();
    }
    function onPointerEnd(e){
     if(!drag||e.pointerId!==drag.id)return;
     // Some laptop input devices deliver only pointerdown/pointerup.
     if(!drag.changed)onPointerMove(e);
     var shouldContinue=drag.changed&&drag.nextPlaying;
     var pointerId=drag.id;
     drag=null;
     try{if(viewport.hasPointerCapture(pointerId))viewport.releasePointerCapture(pointerId)}catch(err){}
     // A pointerup is a user activation, so request YouTube playback here.
     if(shouldContinue)play(slides[current]);
    }
    viewport.addEventListener('pointerdown',onPointerDown);
    viewport.addEventListener('pointermove',onPointerMove);
    viewport.addEventListener('pointerup',onPointerEnd);
    viewport.addEventListener('pointercancel',function(){drag=null});
    viewport.addEventListener('lostpointercapture',function(){drag=null});
    viewport.addEventListener('dragstart',function(e){
     if(e.target.closest && e.target.closest('.mnx55-hero__poster, [data-mnx61-gesture]'))e.preventDefault();
    });
    // Precision touchpads often send horizontal wheel events, not mouse dragging.
    viewport.addEventListener('wheel',function(e){
     if(!e.deltaX||Math.abs(e.deltaX)<16||Math.abs(e.deltaX)<Math.abs(e.deltaY)*1.35)return;
     if(isInteractive(e.target))return;
     if(playing&&!isPlayerGesture(e.target))return;
     if(e.cancelable)e.preventDefault();
     var now=Date.now();
     if(now-wheelLock<600)return;
     wheelLock=now;
     goSwipe(e.deltaX>0?1:-1,playing);
    },{passive:false});
   }
   root.addEventListener('keydown',function(e){
    if(e.target.closest('[data-mnx55-player]'))return;
    if(e.key==='ArrowLeft'){e.preventDefault();show(current-1)}
    else if(e.key==='ArrowRight'){e.preventDefault();show(current+1)}
    else if(e.key==='Escape'){stop(slides[current]);schedule()}
   });
   root.addEventListener('mouseenter',schedule);
   root.addEventListener('mouseleave',schedule);
   root.addEventListener('focusin',schedule);
   root.addEventListener('focusout',function(){window.setTimeout(schedule,0)});
   document.addEventListener('visibilitychange',schedule);
   var observer=null;
   if('IntersectionObserver' in window){
    observer=new IntersectionObserver(function(entries){
     visible=entries.some(function(e){return e.isIntersecting&&e.intersectionRatio>=0.25});
     schedule();
    },{threshold:[0,0.25,0.75]});
    observer.observe(root);
   }
   root.addEventListener('shopify:section:unload',function(){
    clear();
    if(observer)observer.disconnect();
   });
   updatePause();
   show(0);
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});
 else init(document);
 document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
